import * as React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { useMetrics } from "hooks/useMetrics";
import { Link, Spinner } from "components/common";
import { formatCount, getValueFromMetric } from "components/inputs/helpers/InputThroughputUtils";
import Routes from "routing/Routes";
const FAILURE_SUFFIXES = ["failures.input", "failures.processing", "failures.indexing"];
const buildMetricName = (inputId, suffix) => `org.graylog2.inputs.${inputId}.${suffix}`;
const StyledLink = styled(Link)(
  ({ theme, $hasFailures }) => css`
    color: ${$hasFailures ? theme.colors.variant.danger : "inherit"};
    font-weight: ${$hasFailures ? "bold" : "normal"};
  `
);
const FailuresCell = ({ input }) => {
  const { t } = useTranslation("inputs");
  const metricNames = FAILURE_SUFFIXES.map((suffix) => buildMetricName(input.id, suffix));
  const { data: metrics, isLoading } = useMetrics(metricNames);
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, { size: "xs" });
  }
  const totalFailures = metricNames.reduce((sum, metricName) => {
    const aggregated = Object.keys(metrics).reduce(
      (prev, nodeId) => {
        var _a;
        return prev + getValueFromMetric((_a = metrics[nodeId]) == null ? void 0 : _a[metricName]);
      },
      0
    );
    return sum + aggregated;
  }, 0);
  return /* @__PURE__ */ React.createElement(
    StyledLink,
    {
      to: Routes.SYSTEM.INPUT_DIAGNOSIS(input.id),
      title: t("overview.show_diagnosis_for_capitalized", { title: input.title }),
      $hasFailures: totalFailures > 0
    },
    formatCount(totalFailures)
  );
};
export default FailuresCell;
